import apiClient from './config.js';

export default {
  async getCities(search, token) {
    apiClient.interceptors.request.use((config) => {
      // config.headers.post['Content-Type'] = 'multipart/form-data';
      config.headers.get['Accept'] = 'application/json',
      config.headers.get['Content-Type'] =  'application/json'
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    return await apiClient.get(`political_division/cities?search=${search}`);
  },
  async getCadastralBases(token) {
    apiClient.interceptors.request.use((config) => {
      config.headers.get['Accept'] = 'application/json',
      config.headers.get['Content-Type'] =  'application/json'
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    return await apiClient.get(`cadastral/cadastral_bases`);
  },
  async cadastralBasesSearch(npn, token) {
    apiClient.interceptors.request.use((config) => {
      config.headers.get['Accept'] = 'application/json',
      config.headers.get['Content-Type'] =  'application/json'
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    return await apiClient.get(`cadastral/cadastral_bases_search?npn=${npn}`);
  },
  async cadastralAdjacencySearch(npn, base, buffer, token) {
    apiClient.interceptors.request.use((config) => {
      config.headers.get['Accept'] = 'application/json',
      config.headers.get['Content-Type'] =  'application/json'
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    return await apiClient.get(`cadastral/cadastral_adjacency_search?npn=${npn}&base=${base}&buffer=${buffer}`);
  },
  async syncAdjoiningFolio(fmi, color, token) {
    apiClient.interceptors.request.use((config) => {
      config.headers.get['Accept'] = 'application/json',
      config.headers.get['Content-Type'] =  'application/json'
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    color = color.replace('#', '%23');
    return await apiClient.get(`cadastral/update_adjoining?color=${color}&fmi=${fmi}`);
  },
  async getCadastralDomains(token) {
    apiClient.interceptors.request.use((config) => {
      config.headers.get['Accept'] = 'application/json',
      config.headers.get['Content-Type'] =  'application/json'
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    return await apiClient.get('cadastral/cadastral_domains');
  },
  async adjoiningReport(data, token) {
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }, ...config.headers };
      return config;
    });
    return await apiClient.post('cadastral/adjoining_report', data);
  },
};